import { React, useContext, useState } from "react";
import { exact, PropTypes } from "prop-types";
import { Card, Heading, Subtitle } from "uikit/components";
import styles from "./SportsmanTests.module.styl";
import cx from "classnames";
import TestCard from "../TestCard/TestCard";
import { Slider } from "infinite-react-carousel";
import { MediaContext } from "app/media/MediaContext";

export default function SportsmanTests({
    comparisonsWithBest,
    comparisonsWithBestInRegion,
    comparisonsWithTestingSessionRecords,
}) {
    const { isDesktop } = useContext(MediaContext);

    const comparisonsWithBestTab = 1;
    const comparisonsWithBestInRegionTab = 2;
    const comparisonsWithTestingSessionsRecordsTab = 3;

    const [activeTabId, setActiveTabId] = useState(1);

    const comparisonsWithBestTabSliderSettings = {
        className: cx(styles.slider),
        slidesToShow: isDesktop
            ? comparisonsWithBest.length > 7
                ? 7
                : comparisonsWithBest.length - 1
            : comparisonsWithBest.length > 5
            ? 5
            : comparisonsWithBest.length - 1,
        wheel: true,
    };

    const comparisonsWithBestInRegionTabSliderSettings = {
        className: cx(styles.slider),
        slidesToShow: isDesktop
            ? comparisonsWithBestInRegion.length > 7
                ? 7
                : comparisonsWithBestInRegion.length - 1
            : comparisonsWithBestInRegion.length > 5
            ? 5
            : comparisonsWithBestInRegion.length - 1,
        wheel: true,
    };

    const comparisonsWithTestingSessionsRecordsTabSliderSettings = {
        className: cx(styles.slider),
        slidesToShow: isDesktop
            ? comparisonsWithTestingSessionRecords.length > 7
                ? 7
                : comparisonsWithTestingSessionRecords.length - 1
            : comparisonsWithTestingSessionRecords.length > 5
            ? 5
            : comparisonsWithTestingSessionRecords.length - 1,
        wheel: true,
    };

    return (
        <Card borderRadius={"giant"} className={styles.container}>
            <div className={styles.heading}>
                <div className={styles.headingContainer}>
                    <Heading size={isDesktop ? "h2" : "h3"}>Сравнение результатов</Heading>
                </div>
                <div className={styles.controls}>
                    <div
                        className={cx(
                            styles.controlWithBest,
                            activeTabId === 1 && styles.activeTab,
                        )}
                        onClick={() => setActiveTabId(1)}
                    >
                        <Subtitle size={isDesktop ? "subtitle-2" : "subtitle-3"}>
                            С лучшими спортсменами РФ
                        </Subtitle>
                    </div>
                    <div
                        className={cx(
                            styles.controlWithBestRegion,
                            activeTabId === 2 && styles.activeTab,
                        )}
                        onClick={() => setActiveTabId(2)}
                    >
                        <Subtitle size={isDesktop ? "subtitle-2" : "subtitle-3"}>
                            С лучшими спортсменами в субъекте РФ
                        </Subtitle>
                    </div>
                    <div
                        className={cx(
                            styles.controlWithBestTrainingLevel,
                            activeTabId === 3 && styles.activeTab,
                        )}
                        onClick={() => setActiveTabId(3)}
                    >
                        <Subtitle size={isDesktop ? "subtitle-2" : "subtitle-3"}>
                            С рекордами по этапу подготовки в РФ
                        </Subtitle>
                    </div>
                </div>
            </div>
            {activeTabId === comparisonsWithBestTab && (
                <div className={styles.list}>
                    {comparisonsWithBest.length === 0 ? (
                        <div className={styles.noResult}>
                            <Subtitle size={isDesktop ? "subtitle-2" : "subtitle-3"}>
                                На данный момент результатов для сравнения нет!
                            </Subtitle>
                        </div>
                    ) : comparisonsWithBest.length > 1 ? (
                        <Slider {...comparisonsWithBestTabSliderSettings}>
                            {comparisonsWithBest.map((item, index) => (
                                <TestCard key={index} testInfo={item} />
                            ))}
                        </Slider>
                    ) : (
                        comparisonsWithBest.map((item, index) => (
                            <TestCard key={index} testInfo={item} />
                        ))
                    )}
                </div>
            )}
            {activeTabId === comparisonsWithBestInRegionTab && (
                <div className={styles.list}>
                    {comparisonsWithBestInRegion.length === 0 ? (
                        <div className={styles.noResult}>
                            <Subtitle size={isDesktop ? "subtitle-2" : "subtitle-3"}>
                                На данный момент результатов для сравнения нет!
                            </Subtitle>
                        </div>
                    ) : comparisonsWithBestInRegion.length > 1 ? (
                        <Slider {...comparisonsWithBestInRegionTabSliderSettings}>
                            {comparisonsWithBestInRegion.map((item, index) => (
                                <TestCard key={index} testInfo={item} />
                            ))}
                        </Slider>
                    ) : (
                        comparisonsWithBestInRegion.map((item, index) => (
                            <TestCard key={index} testInfo={item} />
                        ))
                    )}
                </div>
            )}
            {activeTabId === comparisonsWithTestingSessionsRecordsTab && (
                <div className={styles.list}>
                    {comparisonsWithTestingSessionRecords.length === 0 ? (
                        <div className={styles.noResult}>
                            <Subtitle size={isDesktop ? "subtitle-2" : "subtitle-3"}>
                                На данный момент результатов для сравнения нет!
                            </Subtitle>
                        </div>
                    ) : comparisonsWithTestingSessionRecords.length > 1 ? (
                        <Slider {...comparisonsWithTestingSessionsRecordsTabSliderSettings}>
                            {comparisonsWithTestingSessionRecords.map((item, index) => (
                                <TestCard key={index} testInfo={item} />
                            ))}
                        </Slider>
                    ) : (
                        comparisonsWithTestingSessionRecords.map((item, index) => (
                            <TestCard key={index} testInfo={item} />
                        ))
                    )}
                </div>
            )}
            <div className={styles.legends}>
                <div className={styles.legend}>
                    <div className={styles.block1} />
                    <div className={styles.name}>спортсмен</div>
                </div>
                <div className={styles.legend}>
                    <div className={styles.block2} />
                    <div className={styles.name}>лидер</div>
                </div>
            </div>
        </Card>
    );
}

const testModel = exact({
    title: PropTypes.string.isRequired,
    moreIsBetter: PropTypes.bool.isRequired,
    measureTypeTitle: PropTypes.string.isRequired,
    currentResult: PropTypes.number.isRequired,
    previousResult: PropTypes.number.isRequired,
    bestResult: PropTypes.number.isRequired,
    normalResult: PropTypes.number.isRequired,
});

SportsmanTests.propTypes = {
    comparisonsWithBest: PropTypes.arrayOf(testModel).isRequired,
    comparisonsWithBestInRegion: PropTypes.arrayOf(testModel).isRequired,
    comparisonsWithTestingSessionRecords: PropTypes.arrayOf(testModel).isRequired,
};
